/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 45
// module chunks = 0